import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useCategoryStore = defineStore('category', {
  state: () => ({
    categories: [],
    loading: false,
    error: null,
    lastFetched: null
  }),
  getters: {
    activeCategories: (state) => {
      return state.categories.filter(category => category.is_active !== false)
    },
    needsRefresh: (state) => {
      // Refresh data if it's older than 30 minutes or if no data exists
      if (!state.lastFetched) return true
      const thirtyMinutesAgo = Date.now() - (30 * 60 * 1000)
      return state.lastFetched < thirtyMinutesAgo
    }
  },
  actions: {
    setCategories(data) {
      this.categories = data || []
    },
    setLoading(loading) {
      this.loading = loading
    },
    setError(error) {
      this.error = error
    },
    async fetchCategories(force = false) {
      // Don't fetch if already loading
      if (this.loading && !force) return
      
      // Don't fetch if data is fresh and not forcing
      if (!this.needsRefresh && !force && this.categories.length > 0) return
      
      this.setLoading(true)
      this.setError(null)
      
      try {
        const data = await api.get('/categories')
        
        // Transform API data to match expected format
        const transformedData = Array.isArray(data) ? data.map(category => ({
          id: category.id,
          name: category.name,
          slug: category.slug || category.name?.toLowerCase().replace(/\s+/g, '-'),
          is_active: category.is_active !== false
        })) : []
        
        this.setCategories(transformedData)
        this.lastFetched = Date.now()
      } catch (error) {
        this.setError(error.message || 'Failed to fetch categories')
        
        // Provide fallback data if API fails
        if (this.categories.length === 0) {
          this.setCategories(this.getMockCategories())
        }
      } finally {
        this.setLoading(false)
      }
    },
    getMockCategories() {
      return [
        { id: 1, name: 'Food & Beverage', slug: 'food-beverage', is_active: true },
        { id: 2, name: 'Retail', slug: 'retail', is_active: true },
        { id: 3, name: 'Services', slug: 'services', is_active: true },
        { id: 4, name: 'Health & Wellness', slug: 'health-wellness', is_active: true },
        { id: 5, name: 'Education', slug: 'education', is_active: true },
        { id: 6, name: 'Automobile', slug: 'automobile', is_active: true },
        { id: 7, name: 'Technology', slug: 'technology', is_active: true },
        { id: 8, name: 'Real Estate', slug: 'real-estate', is_active: true }
      ]
    }
  }
}) 
